import { tns } from 'tiny-slider/src/tiny-slider.module';
import moment from 'moment';
import Component from '../../../scripts/utilities/component';

class NewsCarousel extends Component {
    componentDidMount() {
        this.prevButton = this.mount.querySelector('.news-feature__carousel-button--prev');
        this.nextButton = this.mount.querySelector('.news-feature__carousel-button--next');
        this.navButtons = [...this.mount.querySelectorAll('.news-feature__carousel-button')];
        this.buttonsWrapper = this.mount.querySelector('.news-feature__carousel-nav');
        this.slideItems = [...this.mount.querySelectorAll('.news-feature__item')];

        this.parentWrapper = this.root.parentElement;
        this.tagElm = this.mount.querySelector('.news-feature__item-tag span');
        this.headlineElm = this.mount.querySelector('.news-feature__item-title');
        this.snippetElm = this.mount.querySelector('.news-feature__item-intro');
        this.timeElm = this.mount.querySelector('.news-feature__item-time');
        this.urlLink = this.mount.querySelector('.news-feature__item-detail-link');
        this.initCarousel();

        this.bindEventListeners();

        this.displayNewsContent(1);
    }

    bindEventListeners() {
        this.navButtons.forEach((button) => {
            button.addEventListener('click', this.handleCarouselIndexing.bind(this), true);
        });
        if (this.carousel) {
            this.carousel.events.on('transitionStart', this.handleCarouselIndexing.bind(this), true);
        }
    }

    handleCarouselIndexing(e) {
        const elm = e.currentTarget;

        if (elm) {
            if (elm.classList.contains('news-feature__carousel-button--prev')) {
                this.carousel.goTo('prev');
            }

            if (elm.classList.contains('news-feature__carousel-button--next')) {
                this.carousel.goTo('next');
            }
        }

        const carouselInfo = this.carousel.getInfo();
        const { slideCount } = carouselInfo;
        const currentIndex = carouselInfo.index + 1;

        if (currentIndex === 1) {
            this.prevButton.disabled = true;
        } else {
            this.prevButton.disabled = false;
        }

        if (currentIndex === slideCount) {
            this.nextButton.disabled = true;
        } else {
            this.nextButton.disabled = false;
        }
        this.parentWrapper.classList.add('is--animating');
        this.displayNewsContent(currentIndex);
    }

    initCarousel() {
        this.carousel = tns({
            autoHeight: true,
            container: this.root,
            controls: false,
            items: 1,
            loop: false,
            nav: false,
            slideBy: 'page'
        });

        this.prevButton.disabled = true;
    }

    displayNewsContent(currentIndex) {
        const item = currentIndex - 1;

        if (this.slideItems.length === 1) {
            this.buttonsWrapper.hidden = true;
        }

        const tag = this.slideItems[item].getAttribute('data-tag');
        const headline = this.slideItems[item].getAttribute('data-headline');
        const snippet = this.slideItems[item].getAttribute('data-snippet');
        const publishDate = this.slideItems[item].getAttribute('data-published');
        const link = this.slideItems[item].getAttribute('data-url');

        setTimeout(() => {
            this.tagElm.innerText = tag;
            this.headlineElm.innerText = headline;
            this.snippetElm.innerText = snippet;
            this.timeElm.innerText = moment.utc(publishDate).fromNow();
            this.urlLink.setAttribute('href', link);
            this.parentWrapper.classList.remove('is--animating');
        }, 500);
    }
}

export default NewsCarousel;



// WEBPACK FOOTER //
// ./components/eng-ms-news-feature/scripts/news-feature-carousel.js